/**
 * Class description
 *
 * Created: 2019-08-29
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HorribleHeroesGameModuleConfig} from "../../HorribleHeroesGameModuleConfig";
import {HorribleHeroesParsedGameData} from "../../server/data/HorribleHeroesParsedGameData";
import {SoundManager} from "../../resource/sound/SoundManager";

export class NormalWin implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private _lastNormalWinConfig: IWinRatioConfig;

    /**
     * @constructs
     * @param lastNormalWinConfig
     * @param stagger
     * @param abortStagger
     */
    constructor(lastNormalWinConfig: IWinRatioConfig, stagger?: number, abortStagger?: number) {
        this._lastNormalWinConfig = lastNormalWinConfig;
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: HorribleHeroesParsedGameData): Timeline | null {
        const shakeDuration: number = 2;
        // #414
        if (!(data.singleWin > 0) || data.brokeTheBank) {
            return null;
        }

        const tl: TimelineLite = new TimelineLite();

        if (data.isBigWin) {
            tl.add(() => {
                // #444
                SoundManager.playBigWinInitialWin();

                HorribleHeroesGameModuleConfig.reelBackGroundView.wiggleReelArea(shakeDuration);
                HorribleHeroesGameModuleConfig.reelBackGroundView.shakeStageEffect();
            }, 0);

            tl.add(() => {
            }, shakeDuration);
        } else {
            tl.add([
                () => HorribleHeroesGameModuleConfig.winTextView.playBehindCountup(data.currentWinRatioConfig!),
                HorribleHeroesGameModuleConfig.countUpView.getWinStepAnimation(0, data.singleWin, data.currentWinRatioConfig!)
            ], 0); // changed in #457
        }

        return tl;
    }
}